import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pt-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isNavbarCollapsed = true;

  constructor() { }

  ngOnInit() {
  }

}
